import React, { Component } from 'react'
import PrivateRoute from '../../PrivateRoute'
import { Switch } from 'react-router-dom'
import Grid from './grid'
import Form from './form'

export default class Planos extends Component {
    render() {
        return (
            <div className="hdv-render-div">
                <div className="col-md-12 hdv-bloco-top-space hdv-zera-padding-left-right-boostrap">
                    <Switch>
                        <PrivateRoute exact path='/lns/planos' component={Grid} />
                        <PrivateRoute path='/lns/planos/novo' component={Form} />
                        <PrivateRoute path='/lns/planos/:id/editar/' component={Form} />
                    </Switch>
                </div>
            </div>
        )
    }
}